import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Instagram, Sparkles } from "lucide-react";

interface EmptySocialTopicsProps {
  onGenerateIdeas: () => void;
}

const EmptySocialTopics: React.FC<EmptySocialTopicsProps> = ({ onGenerateIdeas }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-col items-center justify-center p-8 rounded-lg border border-dashed border-zinc-200 dark:border-zinc-700 bg-gradient-to-b from-zinc-50 to-white dark:from-zinc-900 dark:to-zinc-800 text-center h-full min-h-[400px] shadow-sm"
    >
      <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-blue-600 rounded-full flex items-center justify-center mb-6 shadow-lg">
        <Instagram className="h-8 w-8 text-white" />
      </div>
      
      <motion.h3
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-xl font-semibold text-zinc-900 dark:text-white mb-3"
      >
        No Instagram Content Ideas Yet
      </motion.h3>
      
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="text-zinc-500 dark:text-zinc-400 mb-6 max-w-md"
      >
        Generate engaging Instagram content ideas tailored to your brand and audience. Our AI will create visual concepts, captions, and hashtags for your posts.
      </motion.p>
      
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.4, type: "spring", stiffness: 200 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Button 
          onClick={onGenerateIdeas}
          size="lg"
          className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-md hover:shadow-lg transition-all duration-200 gap-2"
        >
          <Sparkles className="h-4 w-4" />
          Generate Content Ideas
        </Button>
      </motion.div>
      
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="text-xs text-zinc-400 dark:text-zinc-500 mt-8 max-w-sm"
      >
        Our AI analyzes trending topics and engagement patterns to suggest content that resonates with your audience and aligns with your brand voice.
      </motion.p>
    </motion.div>
  );
};

export default EmptySocialTopics; 